import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext'
import styled from 'styled-components'
import { useHistory } from 'react-router'

export default function LessonLink({ unit, lesson }) {
  const { appState } = useContext(AppContext)
  const history = useHistory()

  const goToLesson = () => {
    if(!appState.isLessonsLocked || lesson.status !== false) {
      history.push(`/courses/${appState.course.slug}/${unit.key}/${lesson.slug}`)
    }
  }

  return (
    <LessonLinkWrapper className={`lesson-link ${lesson.status ? lesson.status.toLowerCase() : appState.isLessonsLocked && 'locked'}`} onClick={goToLesson}>
      <div className="lesson-image-wrapper">
        {lesson.image && (
          <img src={lesson.image} alt={lesson.title}/>
        )}
        <div className="lesson-status-icon">
          {lesson.status === 'COMPLETED' && (
            <div className="completed"><i className="fas fa-check"></i></div>
          )}
          {appState.isLessonsLocked && lesson.status === false && (
            <div className="locked"><i className="fas fa-lock"></i></div>
          )}
        </div>
      </div>
      <div className="lesson-info">
        <div className="lesson-title">{lesson.title}</div>
      </div>
    </LessonLinkWrapper>
  )
}

const LessonLinkWrapper = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
`